import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { UserPlus, Palette, Rocket } from "lucide-react";

const HowItWorksSection = () => {
  return (
    <div id="how-it-works" className="container text-center py-5">
      <h2 className="fw-bold display-5 mb-2">In 3 Schritten zur organisierten Familie</h2>
      <p className="text-secondary mb-5 fs-5">Keine komplizierte Einrichtung. Einfach starten und loslegen.</p>

      <div className="row justify-content-center align-items-start g-5 mt-4">
        {/* Step 1 */}
        <div className="col-md-4 d-flex flex-column align-items-center">
          <div className="position-relative">
            <div className="bg-primary bg-opacity-10 p-4 rounded-4">
              <UserPlus size={40} className="text-primary" />
            </div>
            <div
              className="position-absolute top-0 start-100 translate-middle bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: "40px", height: "40px", fontWeight: "bold" }}
            >
              01
            </div>
          </div>
          <h4 className="fw-bold mt-4">Konto erstellen</h4>
          <p className="text-secondary px-3">
            In wenigen Sekunden anmelden und euren Familien-Workspace einrichten.
          </p>
        </div>

        {/* Step 2 */}
        <div className="col-md-4 d-flex flex-column align-items-center">
          <div className="position-relative">
            <div className="bg-primary bg-opacity-10 p-4 rounded-4">
              <Palette size={40} className="text-primary" />
            </div>
            <div
              className="position-absolute top-0 start-100 translate-middle bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: "40px", height: "40px", fontWeight: "bold" }}
            >
              02
            </div>
          </div>
          <h4 className="fw-bold mt-4">Personalisieren</h4>
          <p className="text-secondary px-3">
            Familienmitglieder einladen, Kategorien festlegen und den ersten Wochenplan erstellen.
          </p>
        </div>

        {/* Step 3 */}
        <div className="col-md-4 d-flex flex-column align-items-center">
          <div className="position-relative">
            <div className="bg-primary bg-opacity-10 p-4 rounded-4">
              <Rocket size={40} className="text-primary" />
            </div>
            <div
              className="position-absolute top-0 start-100 translate-middle bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: "40px", height: "40px", fontWeight: "bold" }}
            >
              03
            </div>
          </div>
          <h4 className="fw-bold mt-4">Loslegen</h4>
          <p className="text-secondary px-3">
            Termine eintragen, Mahlzeiten planen und den KI-Assistenten für euch arbeiten lassen.
          </p>
        </div>
      </div>
    </div>
  );
}

export default HowItWorksSection;